export var fonts_name = [
  'Abril Fatface',
  'Alice',
  'Arvo',
  'Cardo',
  'Cormorant Garamond',
  'Crimson Text',
  'Fanwood Text',
  'Hind',
  'Fraunces',
  'Inconsolata',
  'Karla',
  'Libre Baskerville',
  'Lora',
  'Lora',
  'Lustria',
  'Nixie One',
  'Nunito',
  'Open Sans Condensed',
  'Oxygen',
  ' DM Sans',
  'Philosopher',
  'Proza Libre',
  'Pt Sans',
  'PT Sans',
  'Quattrocento Sans',
  'Quicksand',
  'Roboto Condensed',
  'Sacramento',
  'Ubuntu',
  'Ultra',
  'Unica One',
  'Yeseva One',
  'Baloo 2',
  'Eczar',
  'Lato',
  'Macondo',
  'Merriweather',
  'Montserrat',
  'Noto Sans',
  'Nunito Sans',
  'Open Sans',
  'Oswald',
  'Playball',
  'Poppins',
  'Quattrocento',
  'PT Sans',
  'Raleway',
  'roboto',
  'Slabo 27px',
  'Source Sans Pro',
  'Space Mono',
  'Work Sans',
]

export const text_name = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'Paragraph', 'Body']
export const font_sizes = [
  { title: 'xs', value: '12px' },
  { title: 'sm', value: '14px' },
  { title: 'base', value: '16px' },
  { title: 'lg', value: '18px' },
  { title: 'xl', value: '20px' },
  { title: '2xl', value: '24px' },
  { title: '3xl', value: '30px' },
  { title: '4xl', value: '36px' },
  { title: '5xl', value: '48px' },
  { title: '6xl', value: '60px' },
  { title: '7xl', value: '72px' },
  { title: '8xl', value: '96px' },
  { title: '9xl', value: '128px' },
]

export const text_cases = [
  { title: 'Default', value: 'unset' },
  { title: 'ag', value: 'lowercase' },
  { title: 'Ag', value: 'capitalize' },
  { title: 'AG', value: 'uppercase' },
]
export const letter_spacing = [
  { title: 'Normal', value: 'normal' },
  { title: 'Tighter', value: '-0.05em' },
  { title: 'Tight', value: '-0.025em' },
  { title: 'Wide', value: '0.025em' },
  { title: 'Wider', value: '0.05em' },
]
export const font_weight = [
  { title: 'Normal', value: 400 },
  { title: 'Medium', value: 500 },
  { title: 'Semibold', value: 600 },
  { title: 'Bold', value: 700 },
  { title: 'Extra Bold', value: 800 },
]

//  object_fit values
export const object_fit_values = [
  { title: 'Fill (Stretch logo to fill container)', value: 'fill' },
  { title: 'Fit (Resize logo to fit container, maintain aspect ratio)', value: 'contain' },
  { title: 'Cover (Resize logo to cover container, maintain aspect ratio)', value: 'cover' },
]
export const object_fit_values2 = [
  { label: 'Fill (Stretch logo to fill container)', value: 'fill' },
  { label: 'Fit (Resize logo to fit container, maintain aspect ratio)', value: 'contain' },
  { label: 'Cover (Resize logo to cover container, maintain aspect ratio)', value: 'cover' },
]

//  logo alignment values
export const logo_alignments_options = [
  { title: 'Center', value: 'center' },
  { title: 'Left', value: 'start' },
]

export const link_target_values = [
  { label: 'Open in new Window', value: '_blank' },
  { label: 'Open in Same Window', value: '_self' },
  { label: 'Open in Same parent Window', value: '_parent' },
]

// justify contents values
export const justify_contents_values = [
  { label: 'Left', value: 'start' },
  { label: 'Space between', value: 'space-between' },
  { label: 'Space evenly', value: 'space-evenly' },
  { label: 'Center', value: 'center' },
]
